import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/Inbox';

import { Assignment, Compare } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { DataGrid, esES } from '@material-ui/data-grid';

import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsUpdate } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

const columns = [
  { field: 'name', headerName: 'Nombre', width: 300, },
  { field: 'description', headerName: 'Descripción', width: 200, flex: 1 },
  { field: 'value', headerName: 'Valor', width: 100, editable: true },
];

export default WithApp(function Varible(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [moduleSelect, setModuleSelect] = useState([]);
  const [variableSelected, setVariableSelected] = useState({});
  const [dataLoading, setDataLoading] = useState(false); //Feedback visual para carga de datos

  async function listModules(idUpdated) {
    setDataLoading(true);
    let response = await wsGetAll('base/configuration');
    setDataLoading(false);
    if (response.success) {
      setModuleSelect(response.data);
      if (idUpdated !== undefined) {
        let obj = response.data.find((item) => item.id == idUpdated);
        setVariableSelected(obj);
      }
    }
  }

  const [dataEdit, setDataEdit] = useState({});
  const [dataEditId, setDataEditId] = useState(null);
  const handleChange = (e) => {
    setDataEdit({ ...dataEdit, [e.field]: e.value });
    setDataEditId(e.id);
  };

  function onCellEditCommit (e) {
    const data = { ...dataEdit, [e.field]: e.value } ;
    let id = e.id;
    updateVariable(id, data);
  }

  async function updateVariable(dataEditId, dataEdit) {
    if (dataEditId !== null) {
      let obj = variableSelected?.configurations?.find((item) => item.id == dataEditId);
      if (obj.value == dataEdit.value) {
        return;
      }
      setDataLoading(true);
      let response = await wsUpdate('base/configuration', dataEditId, dataEdit);
      setDataLoading(false);
      if (response.success) {
        listModules(variableSelected.id);
        setDataEdit({});
        setDataEditId(null);
        showNotify(response.message);
      } else {
        showNotify(response.message, 'error');
      }
    }
  }

  useEffect(() => {
    listModules();
  }, []);
  return (
    <GridContainer>
      <Toasty action={notify} />
      <GridItem xs={5}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de módulos de variables {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody style={{ maxHeight: '65Vh', overflow: 'auto' }}>
            <List component="nav" aria-label="Listado de módulos">
              {moduleSelect.map((item, i) => {
                return (
                  <ListItem
                    key={i}
                    button
                    selected={variableSelected?.id == item?.id}
                    onClick={() => {
                      setVariableSelected(item);
                    }}
                  >
                    <ListItemIcon>
                      <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary={item.description} />
                  </ListItem>
                );
              })}
            </List>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={7}>
        <Card>
          <CardBody>
            <ListItem button>
              <ListItemIcon>
                <Compare />
              </ListItemIcon>
              <ListItemText primary={variableSelected?.description || 'Seleccione un módulo...'} />
            </ListItem>
            {variableSelected?.configurations?.length > 0 ? (
              <div style={{ height: 300, maxHeight: 500, width: '100%', marginTop: '20px' }}>
                <DataGrid
                  localeText={esES.props.MuiDataGrid.localeText}
                  rowHeight={35}
                  disableColumnMenu={true}
                  columns={columns}
                  rows={variableSelected.configurations.map((item, i) => {
                    return {
                      id: item.id,
                      name: item.name,
                      description: item.description,
                      value: item.value,
                    };
                  })}
                  // onEditCellChangeCommitted={() => updateVariable(dataEditId, dataEdit)}
                  // onEditCellChange={handleChange}
                  onCellEditCommit={onCellEditCommit}
                  hideFooterPagination={true}
                />
              </div>
            ) : undefined}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
